export default "__VITE_ASSET__2c197f89__"